import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled.ul`
  margin: 3rem 3.1rem;

  display: flex;

  flex-wrap: wrap;
`;

export const DateFilters = styled(Form)`
  width: 100%;
  display: flex;
  > div {
    width: 260px;
    margin-right: 24px;
  }
  margin: 0rem 3.1rem;
`;

export const CardsContainer = styled.ul`
  margin: 5rem 3.1rem;

  display: flex;

  flex-wrap: wrap;
`;
